import Vue from 'vue'
import Router from 'vue-router'
import Home from "./views/Home";
import Analysis from "./views/Analysis";
import Tools from "./views/Tools";
import Statistics from "./views/Statistics";
import Download from "./views/Download";
import Help from "./views/Help";
import Contact from "./views/Contact";
import AlignAnalysis from "./views/AlignAnalysis";
import MultiAnalysis from "./views/MultiAnalysis";
import AlignFold from "./views/tools/AlignFold";
import MultiFold from "./views/tools/MultiFold";
import ProteinFold from "./views/tools/ProteinFold";
import PDBFold from "./views/tools/PDBFold";

Vue.use(Router);

const router = new Router({
    // mode: 'history',
    // base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name:'home',
            component: Home,
            meta: {
                title: 'RaacFold'
            }
        },
        {
            path: '/align',
            name:'AlignAnalysis',
            component: AlignAnalysis,
            meta: {
                title: 'AlignAnalysis'
            }
        },
        {
            path: '/alignfold/:jobid?/:selected_id?',
            name:'AlignAnalysis',
            component: AlignFold,
            meta: {
                title: 'AlignAnalysis'
            }
        },
        {
            path: '/multifold/:jobid?/:selected_id?',
            name:'MultiFold',
            component: MultiFold,
            meta: {
                title: 'MultiFold'
            }
        },
        {
            path: '/multi',
            name:'MultiAnalysis',
            component: MultiAnalysis,
            meta: {
                title: 'MultiAnalysis'
            }
        },
        {
            path: '/protein',
            name:'protein',
            component: ProteinFold,
            meta: {
                title: 'ProteinAnalysis'
            }
        },
        {
            path: '/pdb',
            name:'pdb',
            component: PDBFold,
            meta: {
                title: 'PDBFold'
            }
        },
        {
            path: '/analysis',
            name:'analysis',
            component: Analysis,
            meta: {
                title: 'Analysis'
            }
        },
        {
            path: '/tools',
            name:'tools',
            component: Tools,
            meta: {
                title: 'Tools'
            }
        },
        {
            path: '/statistics',
            name:'statistics',
            component: Statistics,
            meta: {
                title: 'Statistics'
            }
        },
        {
            path: '/download',
            name:'download',
            component: Download,
            meta: {
                title: 'Download'
            }
        },
        {
            path: '/help',
            name:'help',
            component: Help,
            meta: {
                title: 'Help'
            }
        },
        {
            path: '/contact',
            name:'contact',
            component: Contact,
            meta: {
                title: 'Contact'
            }
        }
    ]
})
router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    next();
})
export default router
// Token Oauth2 验证
// const auth = {
//     isLogin(){
//         return false;
//     }
// }
// 全局守卫
//  路径跳转时，查询路径
// router.beforeEach((to, from, next) => {
//     if (to.path === "/center"){
//         console.log("查询")
//         if(auth.isLogin()){
//             next();
//         }else{
//             next("/login");
//         }
//     }else{
//         next()
//     }
// })
